import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export const jump = (url) => {
  if(url) history.push(url);
}